// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"a59bcc78","785":"a59bcc78"}[chunkId] + ".chunk.css";
};